import { useRegisterContext } from "../../Contexts/RegisterContext";
import { TokenManager } from "@forgerock/javascript-sdk";
import { useAuth } from "../../Contexts/AuthContext";
import { CircularProgress } from "@mui/material";
import Button from "../../Components/Button";
import { useState } from "react";

function ActivateSuccess() {
  const {
    setPersonalMaxicareNumber,
    personalMaxicareNumber,
    selectedType,
    navigate,
    setOtp,
  } = useRegisterContext();

  const [isLoading, setIsLoading] = useState(false);
  const { userData } = useAuth();

  const handleNext = async () => {
    setIsLoading(true);
    const fr_tokens = await TokenManager.getTokens();
    if (fr_tokens) {
      navigate("/home");
      setOtp("");
      setPersonalMaxicareNumber("");
      setIsLoading(false);
    }
  };

  let cardNo = null;
  if (selectedType === "Personal") {
    cardNo = (
      <span className="font-bold text-[#1F2328]">{personalMaxicareNumber}</span>
    );
  } else if (selectedType === "Corporate") {
    cardNo = (
      <span className="font-bold text-[#1F2328]">
        {userData[0]?.cardNo.toString().match(/.{4}/g).join(" ")}
      </span>
    );
  }

  return (
    <div className="flex flex-col items-center min-h-screen max-w-screen sm:bg-[#E7EEFA] cursor-default">
      <div className="bg-white w-screen mb-[56px] sm:my-24 sm:w-148 h-auto rounded-xl sm:justify-center">
        <div className="mt-52 sm:mt-0 flex flex-col items-center justify-center text-center px-6">
          <div className="flex justify-center mt-3">
            <img
              src={require("../../assets/success.png")}
              alt="Personal"
              className="w-24 h-24 flex justify-center"
            />
          </div>
          <div className="text-2xl text-center font-semibold">
            Member Gateway account activated!
          </div>

          <div className=" text-center my-1 mx-3 text-[#60656D]">
            Your Member Gateway account with card&nbsp;{cardNo}&nbsp; is now
            activated. Simply log in with your mobile number for easy access to
            healthcare benefits and your dashboard. Enjoy seamless care!
          </div>
        </div>

        <div className="flex flex-col items-center sm:w-full justify-center absolute p-2 inset-x-0 bottom-0 sm:relative my-2 sm:px-8">
          <Button
            disabled={isLoading}
            className={`w-full h-12 text-white rounded-xl font-semibold sm:ml-2 transition ease-in-out delay-75 hover:scale-105 ${
              isLoading ? "bg-[#F6F7F7]" : "bg-[#0947AB]"
            }`}
            onClick={handleNext}
          >
            {isLoading ? <CircularProgress size={"1rem"} /> : "Continue"}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ActivateSuccess;
